import React from "react";
import { useLocation } from "react-router-dom";

const Header = () => {
  const location = useLocation(); // Get the current route

  // Define a title for each route
  const getTitle = () => {
    switch (location.pathname) {
      case "/owner/dashboard":
        return "Dashboard";
      case "/owner/my-tests":
        return "My Tests";
      case "/owner/sales-reports":
        return "Sales and Reports";
      case "/owner/profile":
        return "Profile";
      default:
        return "Course Dashboard";
    }
  };

  return (
    <header className="flex items-center justify-between border-b border-[#3c2414] bg-[#070604] p-4 shadow-[0_12px_30px_rgba(0,0,0,0.35)]">
      <h1 className="text-2xl font-semibold text-[#ffd66b]">{getTitle()}</h1>
      <div className="flex space-x-4 items-center">
        <button className="relative"></button>
      </div>
    </header>
  );
};

export default Header;
